import AGREGAR_TIPOS_OBRAS from '@/graphql/mutations/administracion/catalogos/tiposobras/agregarTiposObras.gql';
import TIPOS_OBRAS from '@/graphql/querys/administracion/catalogos/tiposobras/tiposObras.gql';
import ACTUALIZAR_TIPO_OBRA from '@/graphql/mutations/administracion/catalogos/tiposobras/actualizarTiposObras.gql';
import REMOVER_TIPO_OBRA from '@/graphql/mutations/administracion/catalogos/tiposobras/removerTipoObra.gql';

export default {
  methods: {
    async mixAgregarTipoObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_TIPOS_OBRAS,
        variables: {
          tipoObra: this.tipoObra,
        },
        update: (store, { data: { agregarTiposObras } }) => {
          const data = store.readQuery({ query: TIPOS_OBRAS });
          data.tiposObras.push(agregarTiposObras);
          store.writeQuery({ query: TIPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarTipoObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_TIPO_OBRA,
        variables: {
          id: this.tipoObraEditar.id,
          tipoObra: this.tipoObra,
        },
        update: (store, { data: { actualizarTiposObras } }) => {
          const data = store.readQuery({ query: TIPOS_OBRAS });
          const { tiposObras } = data;
          const index = tiposObras
            .findIndex((tipoObra) => tipoObra.id
            === actualizarTiposObras.id);
          if (index !== -1) {
            tiposObras.splice(index, 1, actualizarTiposObras);
          }
          store.writeQuery({ query: TIPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarTipoObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_TIPO_OBRA,
        variables: {
          id: this.tipoObraEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: TIPOS_OBRAS });
          const { tiposObras } = data;
          const index = tiposObras
            .findIndex((tipoObra) => tipoObra.id
            === this.tipoObraEliminar.id);
          if (index !== -1) {
            tiposObras.splice(index, 1);
          }
          store.writeQuery({ query: TIPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
